<template>
  <div class="footer">
    <p>版权所有：东北抗日义勇军纪念馆</p>
    <p>备案号：辽ICP备2023011290号</p>
    <p>地址：辽宁省本溪市桓仁满族自治县桓仁镇东关村1组</p>
<!--    <p>联系电话：024-48889088</p>-->
  </div>
</template>

<script>
export default {
  name: "FooterYjjM"
}
</script>

<style scoped>
.footer{
  background: #9E1A28;
  padding:10px 0;
  margin-top: 20px;
  color:#FFECB2;
  font-size: 14px;
  line-height: 25px;
}

</style>
